export const environment = {
  production: false,
  serverUrl: 'https://vms-api.dnvsspl.com/v1/',
  imageUrl: 'https://vms-api.dnvsspl.com/v1/',
  pdfUrl: 'https://vms-api.dnvsspl.com/v1/',

};
